import { AuthService } from "src/app/services/auth.service";
import { Component, NgZone, OnInit } from "@angular/core";
import { CrudService } from "src/app/services/crud.service";
import { environment } from "src/environments/environment";

import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { Geolocation } from "@capacitor/geolocation";
import { Browser } from "@capacitor/browser";
import { ActionSheetController, LoadingController, MenuController, Platform } from "@ionic/angular";
import { loadingProps } from "src/utils/util.functions";
import { LocalNotifications } from "@capacitor/local-notifications";
import { ResponseAPI } from "src/models/user.model";
import { UtilService } from "src/app/services/util.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from '@angular/common';
import { Capacitor } from "@capacitor/core";

@Component({
    selector: "app-start-race",
    templateUrl: "./start-race.page.html",
    styleUrls: ["./start-race.page.scss"],
    providers: [],
    standalone: false
})
export class StartRacePage implements OnInit {
  formCancelation: UntypedFormGroup;
  isOpenCanceling: boolean;
  race: any = { raceType: "" };
  dataPositionUser: {
    latitude: number;
    longitude: number;
    endereco: string;
  } = { latitude: 0, longitude: 0, endereco: "" };
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public load: LoadingController,
    public fb: UntypedFormBuilder,
    public auth: AuthService,
    public crud: CrudService,
    private _ngZone: NgZone,
    public util: UtilService,
    private platform: Platform,
    private location: Location,
    private menuCtrl: MenuController,
    private actionSheetController: ActionSheetController
  ) { }

  ngOnInit() {

  }

  /**
   * Whether the GO/Start Trip button should be visible.
   * Per product requirement: only on the day of the ride (driver's local time, UTC-4 to match codebase convention).
   * If no scheduled date is set (immediate/on-demand trips), allow start.
   */
  isToday(): boolean {
    const scheduled = this.race?.dataAgendamentoCorrida;
    if (!scheduled) return true;
    const scheduledDate = new Date(scheduled);
    if (isNaN(scheduledDate.getTime())) return true;
    // Compare YYYY-MM-DD using UTC-4 (codebase convention)
    const offsetMs = -4 * 60 * 60 * 1000;
    const todayStr = new Date(Date.now() + offsetMs).toISOString().slice(0, 10);
    const schedStr = new Date(scheduledDate.getTime() + offsetMs).toISOString().slice(0, 10);
    return schedStr === todayStr;
  }
  ionViewWillEnter() {
    this.race = JSON.parse(localStorage.getItem("currentRace"));

    this.formCancelation = this.fb.group({
      motivoCancelamento: [""],
      id: [this.race.id],
      canceladoPor: [this.auth.user.name],
      voltarParaEmDisputa: [false],
    });

    this.getLocationUser();
    LocalNotifications.cancel({ notifications: [] }).catch(() => {});
    this.menuCtrl.enable(false);
  }
  ionViewWillLeave() {
    this.menuCtrl.enable(true);
  }
  getLocationUser(): void {
    Geolocation.getCurrentPosition({ enableHighAccuracy: true })
      .then(resp => {
        this.dataPositionUser.latitude = resp.coords.latitude;
        this.dataPositionUser.longitude = resp.coords.longitude;
      })
      .catch(() => { });
  }
  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.load.create(loadingProps);
    return await loading.present();
  }

  navigate(app: string) {
    const destLat = this.race.latitudeOrigem;
    const destLng = this.race.longitudeOrigem;
    const originLat = this.dataPositionUser.latitude;
    const originLng = this.dataPositionUser.longitude;

    switch (app) {
      case "Maps":
        Browser.open({
          url: `https://www.google.com/maps/dir/?api=1&origin=${originLat},${originLng}&destination=${destLat},${destLng}`,
          windowName: "_system"
        }).catch(console.error);
        break;
      case "Waze":
        Browser.open({
          url: `https://www.waze.com/ul?ll=${destLat},${destLng}&navigate=yes`,
          windowName: "_system"
        }).catch(console.error);
        break;
      default:
        Browser.open({
          url: `https://www.google.com/maps/dir/?api=1&origin=${originLat},${originLng}&destination=${destLat},${destLng}`,
          windowName: "_system"
        }).catch(console.error);
    }
  }

  navigateRoundTripReturn(app: string) {
    const destLat = this.race.latitudeDestino;
    const destLng = this.race.longitudeDestino;

    switch (app) {
      case "Maps":
        Browser.open({
          url: `https://www.google.com/maps/dir/?api=1&destination=${destLat},${destLng}`,
          windowName: "_system"
        }).catch(console.error);
        break;
      case "Waze":
        Browser.open({
          url: `https://www.waze.com/ul?ll=${destLat},${destLng}&navigate=yes`,
          windowName: "_system"
        }).catch(console.error);
        break;
      default:
        Browser.open({
          url: `https://www.google.com/maps/dir/?api=1&destination=${destLat},${destLng}`,
          windowName: "_system"
        }).catch(console.error);
    }
  }

  startRace(): void {
    this.showLoading();

    this.crud
      .getData(`${environment.useHubV2 ? 'v2/' : ''}Corrida/iniciar-corrida?id=` + this.race.id, null)
      .subscribe(
        (response: ResponseAPI) => {
          if (response.success) {
            this.load.dismiss();
            this.router.navigate(["/driver", "current-race"], { relativeTo: this.route, skipLocationChange: true });
          }
        },
        () => {
          this.util.showToast("An error occured");
          this.load.dismiss();
        }
      );
  }

  async cancelRace() {
    if (!this.race?.dataAgendamentoCorrida) {
      this.openCancel();
    } else {
      const sheet = await this.actionSheetController.create({
        header: "Cancel trip",
        subHeader: "Select the type of cancellation",
        buttons: [
          {
            text: "Cancel trip",
            handler: () => {
              this.openCancel();
            },
          },
          {
            text: "Send trip back to In Dispute",
            handler: () => {
              this.formCancelation = this.fb.group({
                motivoCancelamento: ["I'm not able to do this trip"],
                id: [this.race.id],
                canceladoPor: [this.auth.user.name],
                voltarParaEmDisputa: [true],
              });
              this.postReason();
            },
          },
          {
            text: "Cancel",
            role: "cancel",
          },
        ],
      });
      await sheet.present();
    }
  }

  private openCancel() {
    this.formCancelation = this.fb.group({
      motivoCancelamento: [""],
      id: [this.race.id],
      canceladoPor: [this.auth.user.name]
    });
    this._ngZone.run(() => {
      this.isOpenCanceling = true;
    });
  }

  postReason() {
    if (this.formCancelation.invalid) {
      return false;
    }
    this.showLoading();

    this.crud
      .postData(`${environment.useHubV2 ? 'v2/' : ''}Corrida/cancelar-corrida`, null, this.formCancelation.value)
      .subscribe(
        (response: ResponseAPI) => {
          if (response.success) {
            this.isOpenCanceling = false;
            this.load.dismiss();
            this.util.showToast("Your information has been sent.");
            this.router.navigate(["/driver", "information-queue"], { relativeTo: this.route, skipLocationChange: true });
          }
        },
        () => {
          this.load.dismiss();
          this.isOpenCanceling = false;
          this.location.back();
          this.util.showToast("An error occured");
        }
      );
  }
}
